import { useTranslation } from "react-i18next";
import { LocalizedLink } from "@/i18n/language";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BausteineConfigurator from "./components/BausteineConfigurator";

export default function BausteinePlanungPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar solid />
      <main>
        <section className="pt-24 md:pt-28 pb-10 md:pb-14">
          <div className="max-w-5xl mx-auto px-4 md:px-8">
            <LocalizedLink
              to="/your-stay"
              className="inline-flex items-center gap-1.5 text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer whitespace-nowrap mb-8"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
              {t("baustein_back")}
            </LocalizedLink>

            <div className="text-center max-w-2xl mx-auto mb-8">
              <div className="mb-4 eyebrow-brand text-xs md:text-sm font-medium tracking-[0.35em] uppercase">
                — {t("baustein_booking_eyebrow")} —
              </div>
              <h1 className="font-heading text-2xl md:text-4xl text-foreground-950 font-medium leading-[1.15] tracking-tight mb-4">
                {t("baustein_booking_title")}
              </h1>
              <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
                {t("baustein_booking_sub")}
              </p>
            </div>

            <BausteineConfigurator />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}